import api from "../api/client";

export async function exportFile(url, params = {}, filename) {
  const res = await api.get(url, {
    params,
    responseType: "blob",    });

  const blob = new Blob([res.data]);
  const downloadUrl = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = downloadUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  window.URL.revokeObjectURL(downloadUrl);
}
